import CusBorder from './cus-border.vue'
const cusBorder = {
  install: function (Vue) {
    Vue.component('CusBorder', CusBorder)
  },
}
export default cusBorder
